import { Component, DestroyRef, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppFeatureService, AppService } from '@nk/access-block';
import { GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { AppFeatureDims, AppIdentityCompositeEntity, AppMembershipEntity } from '@nk/data-entities-lib';
import { simplifyCompanyName } from '@nk/utils-lib';
import { mergeMap } from 'rxjs/operators';

@Component({
  selector: 'nk-header',
  templateUrl: './app-header.component.html',
  standalone: false,
})
export class AppHeaderComponent implements OnInit {
  public collapsedNav: boolean;
  private _customerSlug: string;
  public appMemberships: AppMembershipEntity[];
  public appIdentity: AppIdentityCompositeEntity;
  public activeFeatures: AppFeatureDims = new AppFeatureDims();
  public customerName: string;
  public loggedInWithIdentityProvider = false;
  private _destroy = inject(DestroyRef);

  constructor(
    private _appService: AppService,
    private _appFeatureService: AppFeatureService,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public ngOnInit(): void {
    this.loggedInWithIdentityProvider =
      this._authService.authInfo.idTokenPayload && this._authService.authInfo.idTokenPayload.sub.startsWith('waad|');

    this._appService.identityDataCache
      .get()
      .pipe(
        mergeMap((appIdentity) => {
          this.appIdentity = appIdentity;
          this.customerName = simplifyCompanyName(appIdentity.app_customer.name); // Removes AS, ASA etc
          if (this.customerName.length > 37) {
            this.customerName = this.customerName.substring(0, 40);
            this.customerName = this.customerName + '...';
          }
          return this._appService.appMembershipListByUserCache.get(appIdentity.app_user.uuid);
        }),
        takeUntilDestroyed(this._destroy),
      )
      .subscribe((appMemberships) => {
        this.appMemberships = appMemberships;
      });
    this.collapsedNav = true;
    this._customerSlug = localStorage.getItem('customer_slug');

    this._appFeatureService.appFeatureListByMembershipCache.get().subscribe((activeFeatures) => {
      this.activeFeatures = new AppFeatureDims(activeFeatures);
    });
  }

  public logout(logOutOfMicrosoft = false): void {
    this._authService.logout('userLogout', null, logOutOfMicrosoft);
  }

  public toggleCollapse(): void {
    this.collapsedNav = !this.collapsedNav;
  }

  public onChangeAccount(): void {
    this._authService.removeCustomerSlug();
    window.location.replace('/login'); // a hard http replace will "delete" all angular cache.
  }
}
